import { useQuery } from '@tanstack/react-query'

import { getFeatureFlags } from './userProfile.service'

export const useGetFeatureFlags = (names: string[], enabled: boolean) => {
  return useQuery({
    queryKey: ['getFeatureFlags', names],
    queryFn: () => getFeatureFlags(names),
    enabled,
    // 5 minutes so that it doesn't make a request every time the user navigates to a new page
    staleTime: 1000 * 60 * 5,
  })
}
